export default __webpack_public_path__ + "static/logo-white-7cd057c004bea3c42839a8c6203253e0.png";